
import { useState } from 'react'
import useCurrentTeacher from '../../../../hooks/useCurrentTeacher'
const Experience = () => {
  const { teacher, fetchCurrentTeacher } = useCurrentTeacher()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentExperience, setCurrentExperience] = useState({ experienceYears: '', experienceDescription: '' })
  const [originalIndex, setOriginalIndex] = useState(null) // Track which experience is being edited

  if (!teacher) return null

  // Open modal for edit
  const handleEdit = (experience, index) => {
    setCurrentExperience(experience)
    setOriginalIndex(index)
    setIsModalOpen(true)
  }

  // Open modal for add
  const handleAdd = () => {
    setCurrentExperience({ experienceYears: '', experienceDescription: '' })
    setOriginalIndex(null)
    setIsModalOpen(true)
  }

  // Delete experience
  const handleDelete = async (index) => {
    if (!window.confirm(`Are you sure you want to delete this experience?`)) return

    try {
      const updatedExperiences = teacher.experiences.filter((_, i) => i !== index)
      const formData = new FormData()
      formData.append('experiences', JSON.stringify(updatedExperiences))

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
        },
        body: formData
      })

      if (res.ok) {
        alert('Experience deleted successfully!')
        fetchCurrentTeacher()
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to delete experience')
      }
    } catch (err) {
      console.error(err)
      alert('Error deleting experience')
    }
  }

  // Save (add or update)
  const handleSave = async () => {
    try {
      let updatedExperiences
      if (originalIndex !== null) {
        // Update existing
        updatedExperiences = teacher.experiences.map((exp, i) =>
          i === originalIndex ? currentExperience : exp
        )
      } else {
        // Add new
        updatedExperiences = [...teacher.experiences, currentExperience]
      }

      const formData = new FormData()
      formData.append('experiences', JSON.stringify(updatedExperiences))

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData
      })

      if (res.ok) {
        alert('Experience saved successfully!')
        fetchCurrentTeacher()
        setIsModalOpen(false)
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to save experience')
      }
    } catch (err) {
      console.error(err)
      alert('Error saving experience')
    }
  }

  return (
    <div className="p-2 md:p-6 relative rounded-xl w-full bg-white">
  <div className="flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <h2 className="text-lg font-semibold text-gray-900">Your Experiences</h2>
    </div>
    <button
      className="w-10 h-10 bg-[#0f6abf] text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-[#0a5ca8] transition-colors"
      onClick={handleAdd}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
    </button>
  </div>

  {teacher.experiences && teacher.experiences.length > 0 ? (
    <div className="overflow-hidden rounded-xl border border-gray-200">
      <div className="grid grid-cols-12 bg-gray-50 px-4 py-3 border-b border-gray-200">
        <div className="col-span-3">
          <span className="text-sm font-semibold text-gray-700">Years</span>
        </div>
        <div className="col-span-7">
          <span className="text-sm font-semibold text-gray-700">Description</span>
        </div>
        <div className="col-span-2 text-right">
          <span className="text-sm font-semibold text-gray-700">Actions</span>
        </div>
      </div>
      
      <div className="divide-y divide-gray-100">
        {teacher.experiences.map((exp, index) => (
          <div key={index} className="grid grid-cols-12 items-center px-4 py-3 hover:bg-gray-50/50">
            <div className="col-span-3">
              <div className="flex items-center gap-2">
                {/* <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div> */}
                <span className="text-sm text-gray-900">{exp.experienceYears}</span>
              </div>
            </div>
            <div className="col-span-7">
              <p className="text-sm text-gray-700">{exp.experienceDescription}</p>
            </div>
            <div className="col-span-2 flex justify-end gap-2">
              <button
                className="w-8 h-8 bg-gray-100 text-gray-700 rounded-lg flex items-center justify-center hover:bg-gray-200 transition-colors"
                onClick={() => handleEdit(exp, index)}
              >
                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              <button
                className="w-8 h-8 bg-red-50 text-red-500 rounded-lg flex items-center justify-center hover:bg-red-100 transition-colors"
                onClick={() => handleDelete(index)}
              >
                <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-700 mb-2">No experiences found</h3>
      <p className="text-sm text-gray-500">Add your teaching or professional experiences</p>
    </div>
  )}

  {/* Modal */}
  {isModalOpen && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {originalIndex !== null ? 'Edit Experience' : 'Add Experience'}
              </h3>
              <p className="text-sm text-gray-500 mt-0.5">
                {originalIndex !== null ? 'Update your experience details' : 'Add new teaching or professional experience'}
              </p>
            </div>
          </div>
        </div>
        
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Experience Years</label>
            <input
              type="text"
              placeholder="e.g. 2018-2022, 5 years"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              value={currentExperience.experienceYears}
              onChange={(e) =>
                setCurrentExperience({ ...currentExperience, experienceYears: e.target.value })
              }
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Experience Description</label>
            <textarea
              placeholder="Describe your role, responsibilities, and achievements"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all min-h-[100px] resize-y"
              value={currentExperience.experienceDescription}
              onChange={(e) =>
                setCurrentExperience({ ...currentExperience, experienceDescription: e.target.value })
              }
            />
          </div>
        </div>
        
        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <div className="flex gap-3">
            <button 
              className="flex-1 py-2.5 border border-gray-300 rounded-xl text-sm font-medium hover:bg-gray-100 transition-colors"
              onClick={() => setIsModalOpen(false)}
            >
              Cancel
            </button>
            <button 
              className="flex-1 py-2.5 bg-[#0f6abf] text-white rounded-xl text-sm font-medium hover:bg-[#0a5ca8] transition-colors"
              onClick={handleSave}
            >
              Save Experience
            </button>
          </div>
        </div>
      </div>
    </div>
  )}
</div>
  )
}

export default Experience
